module.exports = "/_next/static/resources/photo-3-2a0e24f852d28b7effa72de818b23993.jpg";